import React, { useCallback, useEffect, useRef } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { useAtom, useAtomValue, useSetAtom } from "jotai";

import "./index.css";
import classes from "./App.module.css";

export default function NotFoundPage() {
  return (
    <div className={classes.pageMain}>
      <main className={classes.main}>
        Page Not Found
      </main>
    </div>
  );
}
